import React from 'react';

import { Alert, Box } from '@mui/material';

const BACKGROUND_SX = {
  display: 'flex',
  justifyContent: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.25)',
  position: 'absolute',
  top: 48,
  left: 0,
  right: 0,
  bottom: 0,
  transition: 'background-color 0.2s',
};

type Props = {
  message: string | null;
};
export default function ErrorMessage({ message }: Props) {
  if (!message) {
    return null;
  }
  return (
    <Box sx={BACKGROUND_SX}>
      <Box sx={{ position: 'absolute', top: 0, zIndex: 'snackbar', left: 0, right: 0 }}>
        <Alert variant="filled" severity="error">
          {message}
        </Alert>
      </Box>
    </Box>
  );
}
